import { render, staticRenderFns } from "./keyboxs.vue?vue&type=template&id=45152bc8&"
import script from "./keyboxs.vue?vue&type=script&lang=js&"
export * from "./keyboxs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports